import {JavascriptViewer} from "@3dweb/360javascriptviewer"

const init = () => {
  const holder = document.querySelectorAll('.jsv-holder')
  const rotationOverlay = document.querySelectorAll('.rotation-slider-overlay')
  const rotationHint = document.querySelectorAll('.rotation-slider-hint')

  const holder1 = document.querySelector('#jsv-holder-1')
  const holderImg1 = document.querySelector('#jsv-image-1')

  const holder2 = document.querySelector('#jsv-holder-2')
  const holderImg2 = document.querySelector('#jsv-image-2')

  const holder3 = document.querySelector('#jsv-holder-3')
  const holderImg3 = document.querySelector('#jsv-image-3')

  const holder4 = document.querySelector('#jsv-holder-4')
  const holderImg4 = document.querySelector('#jsv-image-4')
  
  const viewer = (holderId, imageId) => {
    const viewer = new JavascriptViewer({
      mainHolderId: holderId,
      mainImageId: imageId,
      totalFrames: 36,
      speed: 100,
      defaultProgressBar: true
    });
  
    viewer.start().then(() => {
      viewer.rotateDegrees(0);
    });
  }

  const overlaysDivsAdd = () => {
    if (rotationOverlay.length) {
      rotationOverlay.forEach(element => {
        element.classList.add('active')
      })
    }

    if (rotationHint.length) {
      rotationHint.forEach(element => {
        element.classList.add('active')
      })
    }
  }

  const overlaysDivsRemove = () => {
    if (rotationOverlay.length) {
      rotationOverlay.forEach(element => {
        element.classList.remove('active')
      })
    }

    if (rotationHint.length) {
      rotationHint.forEach(element => {
        element.classList.remove('active')
      })
    }
  }
  
  if (holder1 && holderImg1) {
    viewer('jsv-holder-1', 'jsv-image-1')
  }

  if (holder2 && holderImg2) {
    viewer('jsv-holder-2', 'jsv-image-2')
  }

  if (holder3 && holderImg3) {
    viewer('jsv-holder-3', 'jsv-image-3')
  }

  if (holder4 && holderImg4) {
    viewer('jsv-holder-4', 'jsv-image-4')
  }
  
  if (holder.length) {
    holder.forEach(element => {
      element.addEventListener('mousedown', overlaysDivsAdd)
      element.addEventListener('mouseup', overlaysDivsRemove)
      element.addEventListener('touchstart', overlaysDivsAdd);
      element.addEventListener('touchend', overlaysDivsRemove);
    })
  }
}

init()